import { Theme, createStyles } from '@material-ui/core/styles';

export const styles = (theme: Theme) => createStyles({
    gridContainer: {
        fontFamily: 'MuseoSans, sans-serif',
        margin: '0px 2% 380px 28% ',
        display: 'flex',
        flexDirection: 'row',
        '& #mcVirtual': {
         width: '508px',
         display:'flex',
         alignItems:'center',
         height: 'auto',
            '& img': {
                objectFit: 'contain',
                marginBottom:'0',
            },
        },
        [theme.breakpoints.down(1200)]: {
            margin:'0px 2% 380px 23%',
            '& #mcVirtual': {
             width: '480px',
             '& img': {
                 width:'90%',
             },
            },
        },
        [theme.breakpoints.down(1001)]: {
          margin:'0px 2% 380px 20%',
        },
        [theme.breakpoints.down(905)]: {
          margin:'0px 2% 380px 16%',
        },
        [theme.breakpoints.down(850)]: {
          margin:'0px 2% 330px 16%',
        },
        [theme.breakpoints.down(701)]: {
          flexDirection: 'column',
          margin:'0px 2% 180px 22%',
          '& #mcVirtual': {
           marginTop:'10%',
          },
        },
        [theme.breakpoints.down(650)]: {
          '& #mcVirtual': {
              '& img': {
                  marginRight:'10%',
                   width:'85%',
              },
          },
        },
        [theme.breakpoints.down(601)]: {
          margin:'0px 2% 180px 20%',
          '& #mcVirtual': {
              '& img': {
                   width:'80%',
              },
          },
        },
        [theme.breakpoints.down(550)]: {
          margin:'0px 2% 170px 18%',
          '& #mcVirtual': {
              '& img': {
                   width:'75%',
              },
          },
        },
        [theme.breakpoints.down(500)]: {
          margin:'0px 2% 100px 16%',
        },
        [theme.breakpoints.down(450)]: {
          margin:'0px 0% 140px 13%',
          '& #mcVirtual': {
              '& img': {
                   width:'65%',
              },
          },
        },
        [theme.breakpoints.down(400)]: {
          margin:'0px 0% 100px 13%',
          '& #mcVirtual': {
              '& img': {
                   width:'58%',
              },
          },
        },
        [theme.breakpoints.down(350)]: {
          margin:'0px 0% 100px 15%',
          '& #mcVirtual': {
              '& img': {
                   width:'50%',
              },
          },
        },
    },
    subSectionIndex: {
        fontSize: '18.31px',
        fontWeight: 900,
        color: '#88C3EA',
        flexDirection: 'column',
        marginBottom: '79px',
        letterSpacing: '1.71px',
        [theme.breakpoints.down(1200)]: {
          marginBottom: '70px',
        },
        [theme.breakpoints.down(1001)]: {
          fontSize: '15.5px',
        },
        [theme.breakpoints.down(850)]: {
          marginBottom: '50px',
        },
        [theme.breakpoints.down(701)]: {
          marginBottom: '32px',
          fontSize: '15px',
          lineHeight: '22px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          marginBottom: '28px',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '20px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '19px',
        },
        [theme.breakpoints.down(350)]: {
          lineHeight: '18px',
        },
    },
    textContainer:{
      width:'33%',
      marginRight:'10%',
      [theme.breakpoints.down(1200)]: {
        width:'36%',
      },
      [theme.breakpoints.down(905)]: {
        width:'47%',
        marginRight:'8%',
      },
      [theme.breakpoints.down(701)]: {
        width:'50%',
        marginRight:'0%',
        marginLeft:'20%',
      },
      [theme.breakpoints.down(601)]: {
        width:'55%',
      },
      [theme.breakpoints.down(550)]: {
        width:'68%',
      },
      [theme.breakpoints.down(500)]: {
        width:'72%',
      },
    },
    text: {
        fontSize: '18.3px',
        color: '#3D4274',
        letterSpacing: '0.8px',
        lineHeight: '26.35px',
        fontWeight: 500,
        margin:'0px',
        [theme.breakpoints.down(1001)]: {
            fontSize: '15.5px',
            lineHeight: '25px',
        },
        [theme.breakpoints.down(701)]: {
          fontSize: '15px',
          lineHeight: '22px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          lineHeight: '21px',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '20px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '19px',
        },
        [theme.breakpoints.down(350)]: {
          lineHeight: '18px',
        },
    },
});
